// extracted by mini-css-extract-plugin
export default {"celebrate":"Celebrate-module__celebrate--L9NoK","copilotRun":"Celebrate-module__copilotRun--O7I6c"};